<!--
 * @description: 
 * @Author: HaoJG
 * @Date: 2021-10-12 09:47:12
 * @Lasteditors: HaoJG
 * @LastEditTime: 2022-03-20 09:17:00
-->
<template>
  <div>
    <div class="maintitle">员工考核</div>
    <el-divider></el-divider>
    <el-row class="text-left" :gutter="10">
      <el-col :span='6'>
        <el-input v-model='keyword' placeholder="请输入搜索关键词" size='mini' @keyup.enter.native="searchList"></el-input>
      </el-col>
      <el-button @click="searchList" size='mini'>筛选</el-button>
      <span v-if="leftlist.length >0" style='font-size:12px'><span class="margin-left">剩余{{leftlist.length}}人未提交。</span><span @click="leftDiv=true" style='cursor:pointer;color:blue'>查看名单</span></span>
    </el-row>
    <el-table :data="list" row-key="id" border>
      <el-table-column prop="name" width='100' label="员工姓名"></el-table-column>
      <el-table-column prop="department" width='100' label="部门"></el-table-column>
      <el-table-column prop="month" label="考核月份"></el-table-column>
      <el-table-column label="自评">
        <template slot-scope="scope">
          <span>{{formatExcellent(scope.row.selfexcellent)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="负责人点评">
        <template slot-scope="scope">
          <span>{{formatExcellent(scope.row.leaderexcellent)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button-group>
            <el-button @click="ass(scope)" size='mini'>考核</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background :current-page="page" :page-sizes="pagesizes" :page-size="pagesize" @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    <el-dialog :title="crntname" :visible.sync="assDiv" :show-close="false" width='100%' :close-on-click-modal="false">
      <el-table :data="alist" row-key="id" border width="100%">
        <el-table-column v-for="(item,index) in trList" :key="index" :label="item.label" :width="item.width" :fixed="item.fixed" :align="item.align">
          <template slot-scope="scope">
            <el-input v-model='scope.row[item.prop]' v-if="item.edit==1 && scope.row.readonly!=1" :type="item.type"></el-input>
            <span v-else v-html='scope.row[item.prop]'></span>
            <!-- <span v-html='scope.row[item.prop]' v-if="item.html==1"></span>
            <template v-else>
              <el-input v-model='scope.row[item.prop]' v-if="item.edit==1 && scope.row.readonly!=1" :type="item.type"></el-input>
              <span v-else v-html='scope.row[item.prop]'></span>
            </template> -->
          </template>
        </el-table-column>
      </el-table>
      <table class="excellent-table" v-if='needexcellent==1'>
        <tr>
          <th style='width:300px;'>优秀标准</th>
          <th v-for="(item,index) in shenheList" :key="index">
            {{ item.name }}
          </th>
        </tr>
        <tr v-for='(item,index) in excellentlist' :key='item.id' :index='index'>
          <td v-html="item.standard" class="text-left"></td>
          <td v-for="(it,i) in shenheList" :key="i">
            <span v-if="i!=uuid">{{getBeizhu(item.detail,it.uuid)}}</span>
            <el-input type='textarea' v-model='excellentlist[index].detail[i].beizhu' v-else></el-input>
          </td>
        </tr>
        <tr>
          <td>评选结果</td>
          <td v-for="(item,index) in assessinfo.detail" :key="index">
            <el-select size="mini" v-model="item.excellent" v-if="assessinfo.crntleader==item.uuid">
              <el-option label='不评' :value='0'></el-option>
              <el-option v-for="(item,index) in excellentTypeList" :key='index' :label='item.excellent_title' :value="item.excellent_id"></el-option>
            </el-select>
            <span v-else>{{formatExcellent(item.excellent,1)}}</span>
          </td>
        </tr>
      </table>
      <div>
        <el-button @click="submdfy(1)" v-if='canRefuse==1' size='mini' type='info'>暂存</el-button>
        <el-button @click="submdfy(2)" v-if='canRefuse==1' size='mini' type="success">提交</el-button>
        <el-button @click="refuse" v-if='canRefuse==1' size='mini' type="danger">驳回</el-button>
        <el-button @click="assDiv=false" size='mini'>返回</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="leftDiv" :show-close="false" :close-on-click-modal="false">
      <div class="excellentDiv">
        <li v-for='(item,index) in leftlist' :index='index' :key='index'>
          <span>{{item.name}}</span>
          <span>({{item.department}})</span>
        </li>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="leftDiv = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [], //考核员工列表
      keyword: '',
      total: 0,
      page: sessionStorage.getItem('final_assess_page') ? parseInt(sessionStorage.getItem('final_assess_page')) : 1,
      excellentTypeList: JSON.parse(sessionStorage.getItem('excellentType')),
      info: [],
      assessinfo: {},
      assDiv: false,
      leftDiv: false,
      leftlist: [],
      needexcellent: 1,
      crntname: '',
      excellentlist: [],
      trList: [],
      canRefuse: 0,
      shenheList: {},
      uuid: sessionStorage.getItem('employeeuuid')
    };
  },
  computed: {
    score() {
      let temp = [];
      for (let i in this.info) {
        if (this.info[i][this.uuid + 'did'] != 0)
          temp.push({
            id: this.info[i][this.uuid + 'did'],
            tiid: parseInt(this.info[i].id),
            proportion: this.info[i].proportion,
            score: this.info[i][this.uuid + 'score'] ? parseFloat(this.info[i][this.uuid + 'score']) : 0,
            beizhu: this.info[i][this.uuid + 'beizhu'] ? this.info[i][[this.uuid + 'beizhu']] : '',
          })
      }
      return temp;
    },
    alist() {
      let temp = {
        id: 0,
        title: '合计',
        readonly: 1,
      }
      let shenhe = [];
      for (let item in this.shenheList) {
        shenhe.push(this.shenheList[item].uuid)
        temp[this.shenheList[item].uuid + 'score'] = 0;
      }
      for (let item in this.info) {
        for (let i in shenhe) {
          temp[shenhe[i] + 'score'] += isNaN(parseFloat(this.info[item][shenhe[i] + 'score'])) ? 0 : parseFloat(this.info[item][shenhe[i] + 'score']);
        }
      }
      for (let item in this.assessinfo.detail) {
        if (this.assessinfo.detail[item].uuid == this.uuid) {
          this.assessinfo.detail[item].score = temp[this.uuid + 'score']
          break;
        }
      }
      return this.info.concat(temp);
    },
  },
  methods: {
    getBeizhu(item, uuid) {
      for (let i in item) {
        if (i == uuid) {
          return item[i].beizhu
        }
      }
    },
    getSummaries(param) {
      for (let item in this.list) {
        console.log(this.list[item]);
      }
      return;
      const { columns, data } = param; console.log(columns)
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总价';
          return;
        }
        console.log(data[index])
        const values = data.map(item => Number(item[data.property])); console.log(values)
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = 'N/A';
        }
      })
      console.log(sums)
      return sums;
    },
    searchList() {
      this.page = 1;
      this.getlist();
    },
    getlist() {
      this.$axios({
        url: this.HOST + "/kaohe/leaderass/getAssessList",
        method: "post",
        data: {
          page: this.page,
          pagesize: this.pagesize,
          keyword: this.keyword
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.list = res.data.list.data;
          this.total = res.data.list.total;
          this.leftlist = res.data.leftlist;
        }
      });
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.page = 1;
      this.getlist();
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getlist();
      sessionStorage.setItem('leader_assess_page', p);
    },
    formatExcellent(e, full) {
      if (e == -1) return;
      for (let i in this.excellentTypeList) {
        if (this.excellentTypeList[i].excellent_id == e) return this.excellentTypeList[i].excellent_title;
      }
      if (full) return '不评';
    },
    ass(scope) {
      this.$axios({
        url: this.HOST + "/kaohe/leaderass/getAssByUuid",
        method: "post",
        data: {
          muuid: scope.row.muuid
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.info = res.data.list; console.log(this.info)
          this.assessinfo = res.data.assinfo;
          for (let item in this.assessinfo.detail) {
            this.assessinfo.detail[item].excellent = parseInt(this.assessinfo.detail[item].excellent)
          }
          this.needexcellent = res.data.need_excellent;
          this.crntname = scope.row.name;
          this.assDiv = true;
          this.excellentlist = res.data.excellentlist;
          this.trList = res.data.trList;
          this.canRefuse = res.data.canRefuse;
          this.shenheList = res.data.shenheList
          for (let item in this.assessinfo.detail) {
            if (this.assessinfo.detail[item].uuid == this.uuid) {
              return
            }
          }
          this.assessinfo.detail.push({
            uuid: this.uuid,
            score: 0,
            excellent: 0
          })
        }
      });
    },
    refuse() {
      this.$confirm(
        '确定要驳回考核吗？',
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.$axios({
          url: this.HOST + "/kaohe/leaderass/leaderrefuse",
          method: "post",
          data: {
            aid: this.assessinfo.id,
          },
        }).then((res) => {
          if (res.data.status == 1) {
            this.assDiv = false;
            this.$message({
              type: "info",
              message: "操作成功",
            });
            this.getlist();
          }
        });
      });
    },
    submdfy(status) {
      this.$axios({
        url: this.HOST + "/kaohe/leaderass/saveAss",
        method: "post",
        data: {
          info: this.assessinfo,
          score: this.score,
          status: status,
          excellent: this.excellentlist,
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.$message({
            type: 'success',
            message: res.data.info
          })
          this.assDiv = false;
          this.getlist();
        }
      });
    },
    showLeft() {
      this.$axios({
        url: this.HOST + '/kaohe/leaderass/getLeftList',
        method: 'post',
        data: {}
      }).then(res => {
        if (res.data.status == 1) {
          this.leftlist = res.data.list;
          this.leftDiv = true;
        }
      })
    }
  },
  created: function () {
    this.getlist();
  },
};
</script>